module.exports = __webpack_public_path__ + "img/rock_grey_black.e3c74947.jpg";